import { render, staticRenderFns } from "./EmpfehlungRoot.vue?vue&type=template&id=10224f4d&scoped=true"
import script from "./EmpfehlungRoot.vue?vue&type=script&lang=js"
export * from "./EmpfehlungRoot.vue?vue&type=script&lang=js"
import style0 from "./EmpfehlungRoot.vue?vue&type=style&index=0&id=10224f4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10224f4d",
  null
  
)

export default component.exports